import React from 'react';
import { BsCreditCard2Front, BsSpeedometer2 } from 'react-icons/bs';
import { CiCalendarDate } from 'react-icons/ci';
import { IoColorFillOutline } from 'react-icons/io5';
import { LiaTruckPickupSolid } from 'react-icons/lia';
import { LuKeyRound } from 'react-icons/lu';
import { PiEngineBold, PiGearBold } from 'react-icons/pi';
import { TbCurrencyHryvnia } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { copyToClipboard } from '../../utils/clipboardUtils';
import IconDetail from '../shared/details/IconDetail';

const VehicleInfo = () => {
  const vehicle = useSelector((state) => state.vehicle.vehicle);
  const isMobileView = useSelector((state) => state.screen.isMobileView);
  const iconSize = isMobileView ? '16' : '24';

  return (
    <>
      <hr />
      <div className="hidden lg:grid grid-cols-3">
        <InfoContainer>
          <IconDetail
            className="cursor-pointer"
            onClick={() => copyToClipboard(vehicle.vin, 'VIN скопійовано до буферу')}
            value={vehicle.vin}
            text="VIN"
            icon={<LuKeyRound size={iconSize} />}
          />
          <IconDetail
            value={vehicle.number || 'Не вказано'}
            text="Державний номер"
            icon={<BsCreditCard2Front size={iconSize} />}
          />
          <IconDetail
            value={vehicle.mileage ? `${vehicle.mileage.toLocaleString().replace(/,/g, ' ')} км` : 'Не вказано'}
            text="Пробіг"
            icon={<BsSpeedometer2 size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={vehicle.color?.displayName || 'Не вказано'}
            text="Колір"
            icon={<IoColorFillOutline size={iconSize} />}
          />
          <IconDetail
            value={vehicle.wheelDrive?.displayName || 'Не вказано'}
            text="Привід"
            icon={<LiaTruckPickupSolid size={iconSize} />}
          />
          <IconDetail
            value={vehicle.fuel ? `${vehicle.fuel.displayName} ${vehicle.engine} л` : 'Не вказано'}
            text="Двигун"
            icon={<PiEngineBold size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={vehicle.transmission?.displayName || 'Не вказано'}
            text="Трансмісія"
            icon={<PiGearBold size={iconSize} />}
          />
          <IconDetail
            value={vehicle.year || 'Не вказано'}
            text="Рік випуску"
            icon={<CiCalendarDate size={iconSize} />}
          />
          <IconDetail value={vehicle.rate.name} text="Оцінка вартості" icon={<TbCurrencyHryvnia size={iconSize} />} />
        </InfoContainer>
      </div>

      <div className="grid lg:hidden grid-cols-2 gap-4 md:gap-0">
        <InfoContainer>
          <IconDetail
            className="cursor-pointer"
            onClick={() => copyToClipboard(vehicle.vin, 'VIN скопійовано до буферу')}
            value={vehicle.vin}
            text="VIN"
            icon={<LuKeyRound size={iconSize} />}
          />
          <IconDetail
            value={vehicle.number || 'Не вказано'}
            text="Державний номер"
            icon={<BsCreditCard2Front size={iconSize} />}
          />
          <IconDetail
            value={vehicle.mileage ? `${vehicle.mileage.toLocaleString().replace(/,/g, ' ')} км` : 'Не вказано'}
            text="Пробіг"
            icon={<BsSpeedometer2 size={iconSize} />}
          />
          <IconDetail
            value={vehicle.color?.displayName || 'Не вказано'}
            text="Колір"
            icon={<IoColorFillOutline size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={vehicle.wheelDrive?.displayName || 'Не вказано'}
            text="Привід"
            icon={<LiaTruckPickupSolid size={iconSize} />}
          />
          <IconDetail
            value={vehicle.fuel ? `${vehicle.fuel.displayName} ${vehicle.engine} л` : 'Не вказано'}
            text="Двигун"
            icon={<PiEngineBold size={iconSize} />}
          />
          <IconDetail
            value={vehicle.transmission?.displayName || 'Не вказано'}
            text="Трансмісія"
            icon={<PiGearBold size={iconSize} />}
          />
          <IconDetail value={vehicle.rate.name} text="Оцінка вартості" icon={<TbCurrencyHryvnia size={iconSize} />} />
        </InfoContainer>
      </div>
      <hr />
    </>
  );
};

const InfoContainer = ({ children }) => <div className="flex flex-col gap-4 sm:gap-6 col-span-1">{children}</div>;

export default VehicleInfo;
